import { useState } from "react";
import { useMutation, useQuery } from "react-query";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
//primereact
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { Tooltip } from "primereact/tooltip";
//components
import Modal from "../../../../components/modal/Modal";
//images banks
import itau from "../../../../assets/banks/logo-itau.png";
// import caixa from "../../../../assets/banks/logo-caixa.png";
// import safra from "../../../../assets/banks/banco-safra.png";
import wallet from "../../../../assets/banks/logo-wallet.png";
import sicoob from "../../../../assets/banks/banco-sicoob.png";
import sicredi from "../../../../assets/banks/logo-sicredi.png";
import bradesco from "../../../../assets/banks/logo-bradesco.png";
// import santander from "../../../../assets/banks/logo-santander.png";
import brazilBank from "../../../../assets/banks/banco-do-brasil.png";
//services
import { getAccounts } from "../../../../services/Banks/getAccounts";
import { banks } from "../../../../utils/banks";
import usePermission from "../../../../hooks/usePermission";
import { useAppContext } from "../../../../context/AppContext";
import { getIsIB3 } from "../../../../utils/auth";
import { confirmDialog } from "primereact/confirmdialog";
import { toast } from "react-toastify";
import { deleteAccount } from "../../../../services/Banks/deleteAccount";
import { queryClient } from "../../../../utils/queryClient";

export function Banks() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { permissions } = useAppContext();
  const isIB3 = getIsIB3();
  usePermission("145"); //Visualizar Conta Corrente

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/banks/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Bancos Disponíveis
        </Link>
      ),
    },
  ];

  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  const { data: accounts, isLoading: loadingAccounts } = useQuery({
    queryKey: ["accounts"],
    queryFn: () => getAccounts(),
    enabled: !!permissions?.includes("145"),
  });

  const { mutateAsync: deleteAccountFn } = useMutation({
    mutationFn: deleteAccount,
    onSuccess(_, variables) {
      queryClient.setQueryData(["accounts"], (data) => {
        const updatedTable = data.filter((item) => item.id !== variables);
        const account = data.find((item) => item.id === variables);
        const filteredData = filterDataByBank(updatedTable, account.bank);
        setModalData(filteredData);
        return [...updatedTable];
      });
    },
  });

  //  // console.log(accounts);

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);

  const CustomCard = ({ cardColor, imageUrl, children }) => {
    return (
      <div className={`col-xl-3 col-md-6 pt-4`}>
        <div
          className="card flex justify-content-center text-center rounded-4 px-4 hover-card"
          style={{ backgroundColor: cardColor, height: "100%" }}
        >
          <Card
            className="border-none shadow-none"
            style={{ backgroundColor: cardColor }}
          >
            <div className="row d-flex">
              <div className="pb-3">
                <img
                  width="100%"
                  // width={200}
                  // height={200}
                  src={imageUrl}
                  alt="logo empreendimento"
                />
              </div>
              <div className="overflow-auto">{children}</div>
            </div>
          </Card>
        </div>
      </div>
    );
  };

  // function findBank(data, bank) {
  //   for (let item of data) {
  //     if (item.bank.toLowerCase() === bank.toLowerCase()) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  function filterDataByBank(data, cod) {
    const filteredData = data.filter((item) => item.bank.toString() === cod);
    const owner = banks.find((i) => i.value === cod);
    filteredData.map((i) => ({
      ...i,
      name: owner.label || "Sem Proprietário",
    }));
    return filteredData;
  }

  const handleConfig = (bank, cod) => {
    setSelectedBank(bank);
    if (accounts && accounts.find((i) => i.bank.toString() === cod)) {
      const filteredData = filterDataByBank(accounts, cod);
      setModalData(filteredData);
      setShowModal(true);
    } else {
      navigate(`/banks/${bank}/${id}`, { state: { edit: false } });
    }
  };

  const handleDelete = (account) => {
    confirmDialog({
      message: `Tem certeza que deseja deletar a conta ${account.account_number}-${account.account_digit}?`,
      header: "Deletar Conta",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteCurrentAccount(account.id),
    });
    // Add your delete logic here
  };

  const deleteCurrentAccount = async (id) => {
    const notification = toast.loading("Aguarde...");

    try {
      await deleteAccountFn(id);
      toast.update(notification, {
        render: "Conta deletada com sucesso!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      toast.update(notification, {
        render: "Não foi possível deletar a conta, tente novamente!",
        autoClose: 1000,
        theme: "colored",
        type: "error",
        isLoading: false,
      });
    }
  };

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {loadingAccounts ? (
        <div className="row">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="col-xl-3 pt-4">
              <Skeleton
                className="flex justify-content-center text-center rounded-4 px-4 hover-card"
                width="100%"
                height="450px"
              ></Skeleton>
            </div>
          ))}
        </div>
      ) : isIB3 ? (
        <div className="row">
          <CustomCard cardColor="#00006e" imageUrl={wallet}>
            <Button
              rounded
              raised
              outlined
              severity="info"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("wallet_ib", "999")}
            />
          </CustomCard>
        </div>
      ) : (
        <div className="row">
          <CustomCard cardColor="#00006e" imageUrl={wallet}>
            <Button
              rounded
              raised
              outlined
              severity="info"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("wallet_ib", "999")}
            />
          </CustomCard>
          <CustomCard cardColor="#FFF200" imageUrl={brazilBank}>
            <Button
              rounded
              raised
              severity="info"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("bb", "001")}
            />
          </CustomCard>
          {/* <CustomCard cardColor="#EC0000" imageUrl={santander}>
            <Button
              rounded
              raised
              severity="danger"
              icon="pi pi-cog"
              className="my-2 white-button"
              label="Configurar"
              onClick={() => handleConfig("santander", "033")}
            />
          </CustomCard> */}
          <CustomCard cardColor="#64C832" imageUrl={sicredi}>
            <Button
              rounded
              raised
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("sicredi", "748")}
            />
          </CustomCard>
          {/* <CustomCard cardColor="#FFFFFF" imageUrl={safra}>
            <Button
              rounded
              raised
              // outlined
              severity="secondary"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("safra", "422")}
            />
          </CustomCard> */}
          <CustomCard cardColor="#ED7408" imageUrl={itau}>
            <Button
              rounded
              raised
              // outlined
              severity="warning"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("itau", "341")}
            />
          </CustomCard>
          {/* <CustomCard cardColor="" imageUrl={caixa}>
            <Button
              rounded
              raised
              // outlined
              severity="info"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("caixa", "104")}
            />
          </CustomCard> */}
          <CustomCard cardColor="#033C45" imageUrl={sicoob}>
            <Button
              rounded
              raised
              outlined
              // severity="info"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("sicoob", "756")}
            />
          </CustomCard>
          <CustomCard cardColor="" imageUrl={bradesco}>
            <Button
              rounded
              raised
              outlined
              severity="danger"
              icon="pi pi-cog"
              className="my-2"
              label="Configurar"
              onClick={() => handleConfig("bradesco", "237")}
            />
          </CustomCard>
        </div>
      )}
      {/* modal  */}
      <Modal
        visible={showModal}
        position="top"
        onHide={() => setShowModal(false)}
        dynamicWidth={window.innerWidth <= 992 ? "85vw" : "60vw"}
        dynamicTitle="Selecione a conta desejada" // Use o título dinâmico aqui
      >
        <div className="px-3 pt-5">
          {/* <form onSubmit={handleSubmit(handleCalculateValue)}> */}
          <div className="row">
            {modalData &&
              modalData?.map((account) => (
                <div
                  key={account?.id}
                  className={`card hover-card form-control ${
                    account?.in_use ? "account-used" : ""
                  }`}
                  onClick={(e) => {
                    if (!e.target.closest(".prevent-parent-click")) {
                      navigate(`/banks/${selectedBank}/${id}`, {
                        state: { accountId: account?.id, edit: true },
                      });
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <div className="card-body p-0">
                    <div className="row justify-content-end">
                      <div className="col-sm-10">
                        <div className="d-flex align-items-center ml-auto my-3">
                          {account.homologation ? (
                            <>
                              <div
                                className="rounded-circle bg-success me-2"
                                style={{ width: "15px", height: "15px" }}
                                data-pr-tooltip="Homologada"
                              ></div>
                              <Tooltip target=".bg-success" position="top" />
                            </>
                          ) : (
                            <></>
                          )}
                          <h4 className="m-0 mx-3">
                            Agência: {account?.agency} - {account?.agency_digit}
                          </h4>
                          <h4 className="m-0">
                            Conta: {account?.account_number} -{" "}
                            {account?.account_digit}
                          </h4>
                          <h4 className="m-0 mx-3">
                            Proprietário: {account?.company.name}
                          </h4>
                        </div>
                      </div>
                      <div className="col-sm-1">
                        {!account.in_use && (
                          <div className="d-flex align-items-center ml-auto my-3 text-red">
                            <div className="mx-2 prevent-parent-click">
                              <i
                                className="fa-solid fa-trash-can h3"
                                data-pr-tooltip="Excluir"
                                onClick={() => handleDelete(account)}
                              ></i>
                              <Tooltip target=".fa-trash-can" position="top" />
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-sm-1">
                        <div className="d-flex align-items-center ml-auto my-3">
                          <div className="mx-2">
                            <i className="fa-solid fa-chevron-right h3"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div className="pt-5 text-center">
              <Button
                rounded
                icon="fa fa-solid fa-plus"
                onClick={() =>
                  navigate(`/banks/${selectedBank}/${id}`, {
                    state: { edit: false },
                  })
                }
                className="p-inputtext-sm m-auto"
              />
            </div>
          </div>
          {/* </form> */}
        </div>
      </Modal>
      {/* end modal  */}
    </>
  );
}
